<!-- src/components/ImageWithValidation.vue -->
<template>
  <v-img
    :src="currentSrc"
    :alt="alt"
    @error="handleError"
    v-bind="$attrs"
  >
    <div class="fill-height">
      <slot/>
    </div>
  </v-img>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ''
    },

    srcDefault: {
      type: String,
      default: '',
      required: true
    },

    alt: {
      type: String,
      default: 'Image'
    },
    preValidate: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      currentSrc: '',
      hasError: false
    }
  },

  watch: {
    src: {
      immediate: true,
      handler (newsrc) {
        this.loadImage(newsrc)
      }
    }
  },

  methods: {
    async loadImage (src) {
      this.hasError = false
      if (!src) {
        this.currentSrc = this.srcDefault
        return
      }

      if (!this.preValidate) {
        this.currentSrc = src
        return
      }
      const isValid = await this.checkImageExists(src)

      if (isValid) {
        this.currentSrc = src
      } else {
        this.currentSrc = this.srcDefault
      }
    },

    checkImageExists (src) {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false)
        img.src = src
      })
    },

    handleError () {
      if (!this.hasError) {
        this.hasError = true
        this.currentSrc = this.srcDefault
        this.$emit('fallback-used')
      }
    }
  }
}
</script>
